/* eslint-disable jsx-a11y/anchor-has-content */
import 'twin.macro'

import SubBody from 'components/UI/sub-body/sub-body'
import SubTitle from 'components/UI/sub-title/sub-title'
import OtpVerify from 'components/views/otp-verify'
import React, { useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { Trans, useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { useOfflineOtpVerifyMutation } from 'redux/api/otp.api'
import tw from 'twin.macro'
import { pathnames } from 'utils/steps'
function OfflineOtpPage() {
  const { t } = useTranslation()
  const [otpVerify, { isLoading, isSuccess }] = useOfflineOtpVerifyMutation()
  const navigate = useNavigate()
  const {
    control,
    formState: { isValid },
    watch,
    setError
  } = useForm({ defaultValues: { code: '' } })

  const handleOtpVerify = async () => {
    try {
      await otpVerify({ code: watch('code') }).unwrap()
    } catch (e) {
      const typedErr = e as {
        data: {
          error: { description: string }
        }
        status: number
      }
      if (typedErr.data.error.description) {
        setError('code', { type: 'validate', message: typedErr.data.error.description })
      }
    }
  }

  useEffect(() => {
    isSuccess && navigate(pathnames['offline-success'])
  }, [isSuccess])

  return (
    <div tw='relative z-10 bg-secondary sm:min-w-[370px] max-w-[440px] w-full mx-auto rounded-s20 p-8 flex flex-col gap-4 justify-center'>
      <p tw='text-s18 font-medium'>{t('modal_title', { ns: 'otp' })}</p>
      <OtpVerify
        // phone={watch('')}
        control={control}
        name='code'
        isOtpValid={isValid}
        isLoading={isLoading}
        onOtpVerify={handleOtpVerify}
      />
      <SubBody twStyle={tw`text-secondary`}>
        <Trans
          components={{
            link1: (
              <a
                onClick={() =>
                  window.open('https://bankffin.kz/storage/docs/DW6oJlZFR8SQOYyRgJuIdKMYLXAj4M7qbhtMzdma.pdf', '_self')
                }
                href='https://bankffin.kz/storage/docs/DW6oJlZFR8SQOYyRgJuIdKMYLXAj4M7qbhtMzdma.pdf'
                tw='underline font-bold'
              />
            )
          }}
        >
          {t('agreement', {
            ns: 'offlineClient'
          })}
        </Trans>
      </SubBody>
    </div>
  )
}

export default OfflineOtpPage
